import * as React from 'react'

import { TaskStatusWrapper } from '@/modules/shared/components'
import ViewMode from './ViewMode'
import YearPickerButton from '../datepickers/YearPickerButton'
import { useDriversGroupTimesheetStore } from '@/modules/drivers/stores/driversGroupTimesheetStore'
import { useShallow } from 'zustand/shallow'
import { withRouter } from '@/app/navigation/withRouter'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'

const DriversGroupTmesheetControlBar = () => {
  const { t } = useLocalize()
  const { activeViewMode } = useDrivers()
  const { viewedYear, setViewedYear } = useDriversGroupTimesheetStore(
    useShallow((s) => ({
      viewedYear: s.viewedYear,
      setViewedYear: s.setViewedYear,
    })),
  )

  return (
    <TaskStatusWrapper>
      <div className="tw-relative tw-flex tw-w-full tw-flex-row tw-justify-start  tw-items-center tw-gap-2 tw-border-b md:tw-gap-4">
          <ViewMode padding />
          <div className="tw-py-2 tw-font-medium tw-text-nowrap tw-text-content-base">
            {activeViewMode === 'group'
              ? t('common.view-mode-group')
              : t('common.view-mode-single')}
          </div>
        <div className="tw-z-[200] tw-flex tw-w-full tw-flex-wrap-reverse  tw-justify-end tw-gap-2 tw-px-4 tw-py-2 sm:tw-items-center sm:tw-justify-end sm:tw-gap-6">
          <YearPickerButton
            value={viewedYear}
            handleChangeValue={setViewedYear}
          />
        </div>
      </div>
    </TaskStatusWrapper>
  )
}

export default withRouter(DriversGroupTmesheetControlBar)
